// Google Analytics 4 Configuration
// Replace 'G-XXXXXXXXXX' with your actual GA4 Measurement ID

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-2R1G8276BR';

// Initialize Google Analytics with mobile optimization
export const initGA = () => {
  if (typeof window !== 'undefined' && GA_MEASUREMENT_ID) {
    // Check if gtag is already loaded
    if (window.gtag) {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_title: 'Podcast Archive',
        page_location: window.location.href,
        // Mobile optimizations
        transport_type: 'beacon',
        custom_map: {
          'custom_parameter_1': 'mobile_optimized'
        }
      });
    } else {
      // Wait for gtag to load
      const checkGtag = () => {
        if (window.gtag) {
          window.gtag('config', GA_MEASUREMENT_ID, {
            page_title: 'Podcast Archive',
            page_location: window.location.href,
            transport_type: 'beacon'
          });
        } else {
          setTimeout(checkGtag, 100);
        }
      };
      checkGtag();
    }
  }
};

// Track page views
export const trackPageView = (pageName, pageTitle) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_title: pageTitle,
      page_location: window.location.href,
      custom_map: {
        'custom_parameter_1': 'page_name'
      }
    });
    
    window.gtag('event', 'page_view', {
      page_name: pageName,
      page_title: pageTitle,
      page_location: window.location.href
    });
  }
};

// Track podcast interactions for monetization
export const trackPodcastPlay = (podcastId, podcastTitle, duration) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'podcast_play', {
      event_category: 'Podcast',
      event_label: podcastTitle,
      podcast_id: podcastId,
      podcast_title: podcastTitle,
      estimated_duration: duration,
      engagement_time_msec: 0
    });
  }
};

export const trackPodcastPause = (podcastId, podcastTitle, currentTime) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'podcast_pause', {
      event_category: 'Podcast',
      event_label: podcastTitle,
      podcast_id: podcastId,
      podcast_title: podcastTitle,
      current_time: currentTime
    });
  }
};

export const trackPodcastComplete = (podcastId, podcastTitle, totalDuration) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'podcast_complete', {
      event_category: 'Podcast',
      event_label: podcastTitle,
      podcast_id: podcastId,
      podcast_title: podcastTitle,
      total_duration: totalDuration,
      value: 1 // This can be used for conversion tracking
    });
  }
};

// Track search and discovery
export const trackSearch = (searchTerm, resultsCount) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'search', {
      search_term: searchTerm,
      results_count: resultsCount,
      event_category: 'Discovery'
    });
  }
};

// Track playlist interactions
export const trackPlaylistAdd = (podcastId, podcastTitle) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'add_to_playlist', {
      event_category: 'Playlist',
      event_label: podcastTitle,
      podcast_id: podcastId,
      podcast_title: podcastTitle
    });
  }
};

// Track comment interactions
export const trackCommentPost = (podcastId, commentLength) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'comment_post', {
      event_category: 'Engagement',
      podcast_id: podcastId,
      comment_length: commentLength
    });
  }
};

// Track user engagement time
export const trackEngagementTime = (podcastId, timeSpent) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'engagement_time', {
      event_category: 'Engagement',
      podcast_id: podcastId,
      time_spent: timeSpent
    });
  }
};

// Track conversion events (for monetization)
export const trackConversion = (conversionType, value = 0) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      event_category: 'Monetization',
      event_label: conversionType,
      value: value,
      currency: 'USD'
    });
  }
};

// Track ad impressions (if you add ads later)
export const trackAdImpression = (adSlot, adType) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'ad_impression', {
      event_category: 'Advertising',
      ad_slot: adSlot,
      ad_type: adType
    });
  }
};

// Track user demographics and interests (for better targeting)
export const trackUserSegment = (segment) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'user_segment', {
      event_category: 'Demographics',
      user_segment: segment
    });
  }
};

// Generic GA4 custom-event helper. Used for the PWA-install events
// (pwa_install, pwa_install_prompt) — see usePwaInstallAnalytics + useInstallPrompt.
export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

// Set GA4 user properties (e.g. display_mode). Unlike events, user properties
// stick to the user across sessions and are what GA4 audiences/segments key
// off — so this is how we flag "this user runs the installed PWA" (the only
// way to gauge iOS installs, which fire no install event).
export const setUserProperties = (props) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('set', 'user_properties', props);
  }
};

export default {
  initGA,
  trackPageView,
  trackPodcastPlay,
  trackPodcastPause,
  trackPodcastComplete,
  trackSearch,
  trackPlaylistAdd,
  trackCommentPost,
  trackEngagementTime,
  trackConversion,
  trackAdImpression,
  trackUserSegment,
  trackEvent,
  setUserProperties
};
